<div *ngIf="form">
  <form class="schshm-container k-p-8 k-bg-white" [formGroup]="form">
    <div class="shm-heading">
      <div class="k-d-inline-flex k-w-full">
        <fa-icon icon="calendar" class="fa-md k-pr-2 k-pb-2 icon-color k-align-self-center"></fa-icon>
        <h4 class="k-w-full heading-cls" *ngIf="!isReSchedule">
          Schedule Meeting (DOE/Non-DOE)
        </h4>
        <h4 class="k-w-full heading-cls" *ngIf="isReSchedule">
          Re-Schedule Meeting (DOE/Non-DOE)
        </h4>
      </div>
      <div>
        <p class="secondary-color"><b>Assessments for scheduling meeting :
          </b><span>{{evaluationDetails.evaluationName}}</span>
        </p>
      </div>
      <div class="loading-container" *ngIf="loadSpinner">
        <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
      </div>
    </div>

    <!-- Currently Scheduled Meeting -->
    <div *ngIf="isReSchedule">
      <p class="assessment-shm">
        Currently Scheduled Meeting
      </p>
      <kendo-grid [kendoGridBinding]="scheduleMeetingList">
        <kendo-grid-column field="CurrScheduleDt" title="Date and Time" [width]="250">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{formatMeetingTime}}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Location" title="Location" [width]="250">
        </kendo-grid-column>
      </kendo-grid>
    </div>

    <!-- Student Information -->
    <div class="col k-d-inline-flex">
      <fa-icon icon="user" class="custom-icon-color k-align-self-center"></fa-icon>
      <div class="k-ml-9">
        <h4 class="primary-color font-14">
          {{ studentDetails?.lastName }}, {{ studentDetails?.firstName }}
        </h4>
        <p class="secondary-color k-mt-0">
          Student ID: {{ studentDetails?.nycid }} | DOB: {{ studentDetails?.dob | date : "MM/dd/yyyy" }} | Age: {{
          studentDetails?.age }}
        </p>
      </div>
    </div>
    <!-- Evaluator Information -->
    <div class="k-d-flex k-w-full k-mt-4">
      <fa-icon icon="chalkboard-user" class="fa-md k-pr-2 custom-icon-color k-align-self-center"></fa-icon>
      <kendo-formfield class="form-field k-ml-6">
        <kendo-label text="Evaluator Name">
          <kendo-textbox rounded="large" fillMode="outline" formControlName="evaluatorName"
            class="disabled additional-info"></kendo-textbox>
        </kendo-label>
      </kendo-formfield>
      <kendo-formfield class="form-field">
        <kendo-label text="Evaluator Title">
          <kendo-textbox [size]="'medium'" [rounded]="'large'" [fillMode]="'outline'" formControlName="evaluatorTitle"
            class="additional-info"></kendo-textbox>
        </kendo-label>
      </kendo-formfield>
      <kendo-formfield class="form-field">
        <kendo-label text="Evaluator Phone">
          <kendo-maskedtextbox [size]="'medium'" [rounded]="'large'" formControlName="evaluatorPhone"
            [fillMode]="'outline'" mask="(000) 000-0000" class="additional-info"></kendo-maskedtextbox>
        </kendo-label>
        <kendo-formerror>{{ form.get('evaluatorPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message ?? 'Error:
          Enter a valid 10-digit phone number' }}</kendo-formerror>
      </kendo-formfield>
      <kendo-formfield class="form-field">
        <kendo-label text="Evaluator Email">
          <kendo-textbox [size]="'medium'" [rounded]="'large'" [fillMode]="'outline'" formControlName="evaluatorEmail"
            class="additional-info"></kendo-textbox>
        </kendo-label>
        <kendo-formerror>{{ form.get('evaluatorEmail')?.errors?.validateEmail?.message }}</kendo-formerror>
      </kendo-formfield>
    </div>

    <div class="k-pb-2"></div>

    <span class="k-form-separator k-pb-4"></span>

    <div class="separator-div"></div>

    <div class="attendees-div">
      <div class="k-mt-5">
        <div class="k-d-inline-flex location-div">
          <fa-icon icon="location-dot" class="fa-md k-pr-2 custom-icon-color k-align-self-center"></fa-icon>
          <kendo-formfield showHints="always" showErrors="initial" class="k-w-full k-ml-6">
            <kendo-textbox rounded="large" [fillMode]="'outline'" placeholder="Location *" class="location-textbox"
              formControlName="meetingStreetAddress1"></kendo-textbox>
          </kendo-formfield>
        </div>
        <div class="k-d-inline-flex k-ml-4">
          <fa-icon icon="stairs" class="fa-md k-pr-2 k-ml-2 custom-icon-color k-align-self-center"></fa-icon>
          <kendo-formfield showHints="always" showErrors="initial" class="k-w-full k-ml-2">
            <kendo-textbox rounded="large" [fillMode]="'outline'" placeholder="Floor/Room"
              formControlName="meetingFloorRoom">
            </kendo-textbox>
          </kendo-formfield>
        </div>
      </div>
    </div>

    <div class="k-mt-4">
      <div class="k-d-inline-flex">
        <fa-icon icon="clock" class="fa-md k-pr-2 custom-icon-color k-align-self-center"></fa-icon>
        <kendo-formfield class="form-field k-ml-7">
          <kendo-label text="Meeting Date"><span class="required"> *</span>
            <kendo-datepicker id="meetingDate" calendarType="classic" placeholder="MM/DD/YYYY" [format]="format"
              formControlName="meetingDate" [max]="maxMeetingDate" [min]="minMeetingDate"
              class="additional-info"></kendo-datepicker>
          </kendo-label>
          <kendo-formerror *ngIf="form.get('meetingDate').hasError('required')">Error: Please select meeting
            date</kendo-formerror>
          <kendo-formerror *ngIf="form.get('meetingDate').hasError('maxError')">Error: Date cannot be more than 1 year
            from today</kendo-formerror>
          <kendo-formerror *ngIf="form.get('meetingDate').hasError('minError')">Error: Date can not be earlier than PWN
            Notice Date</kendo-formerror>
        </kendo-formfield>
        <div class="k-d-inline-flex k-ml-2">
          <kendo-formfield class="form-field">
            <kendo-label text="Start Time"><span class="required"> *</span>
              <kendo-timepicker id="meetingStartTime" formControlName="meetingStartTime" [min]="timePickerMin"
                [max]="timePickerMax" [value]="timePickerValue" [rangeValidation]="true"
                class="additional-info"></kendo-timepicker>
            </kendo-label>
            <kendo-formerror>Error: Please select start time</kendo-formerror>
          </kendo-formfield>&nbsp;
          <fa-icon icon="arrow-right"
            class="fa-md k-pr-2 custom-icon-color k-align-self-center custom-right-icon"></fa-icon>&nbsp;
          <kendo-formfield class="form-field">
            <kendo-label text="End Time"><span class="required"> *</span>
              <kendo-timepicker id="meetingEndTime" formControlName="meetingEndTime" class="additional-info"
                [min]="getMeetingEndTimeValue()"></kendo-timepicker>
            </kendo-label>
            <kendo-formerror>Error: Please select end time</kendo-formerror>
          </kendo-formfield>
        </div>
      </div>
    </div>

    <div class="k-d-inline-flex k-w-full k-mt-4">
      <fa-icon icon="indent" class="fa-md k-pr-2 custom-icon-color k-align-self-center"></fa-icon>
      <kendo-formfield showHints="always" showErrors="initial" class="k-w-full k-mt-2 k-ml-8">
        <kendo-label text="Additional Information">
          <kendo-textarea placeholder="Type here" [rows]="3" resizable="horizontal" class="k-w-full additional-info"
            formControlName="additionalInfo"></kendo-textarea>
        </kendo-label>
      </kendo-formfield>
    </div>
    <div *ngIf="!form || loadSaveSpinner" class="k-d-flex k-w-full k-justify-content-center">
      <kendo-loader type="converging-spinner" size="large"></kendo-loader>
    </div>
    <div class="page-footer k-mt-2 k-text-right">
      <div class="action-btns">
        <div class="action-btns__right">
          <button type="button" kendoButton size="large" rounded="large" fillMode="outline" themeColor="error"
            (click)="openConfirmationDialog()">
            Cancel
          </button>
          &nbsp;
          <button kendoButton themeColor="primary" size="large" rounded="large" fillMode="solid" (click)="submit()"
            [disabled]="!form?.valid">
            Schedule Appointment
          </button>
        </div>
      </div>
    </div>
  </form>
</div>



<kendo-dialog title="Please confirm" *ngIf="confirmationDialog" (close)="closeConfirmationDialog()"
  class="custom-dialog">
  <p>Are you sure you want to cancel?</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeConfirmationDialog()" fillMode="outline">No</button>
    <button kendoButton (click)="onCancelSEM()" themeColor="primary" fillMode="solid">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>